/**
 * Glow Price admin brand design tokens.
 *
 * Centralized palette for the admin console. Pages and components should
 * read from antd's ConfigProvider rather than these constants directly so
 * the theme can be re-themed in a single place.
 */
export const GLOW_TOKENS = {
  colors: {
    primary: "#8B1A2B",
    primaryHover: "#B7456A",
    bgLayout: "#FAF6F0",
    bgContainer: "#FFFFFF",
    border: "#E8DFD3",
    textPrimary: "#1A1A1A",
    textSecondary: "#6B6B6B",
    success: "#2E7D5B",
    warning: "#B7791F",
    error: "#9B2226",
    siderBg: "#1F1A1B",
    siderHoverBg: "#2F2628",
    siderText: "#FAF6F0",
    tableHeaderBg: "#FAF6F0",
    tableRowHoverBg: "#F7F1E8",
  },
  fontFamily:
    "Inter, 'PingFang SC', system-ui, -apple-system, sans-serif",
  borderRadius: 8,
  borderRadiusLG: 12,
  controlHeight: 40,
  boxShadow:
    "0 1px 3px rgba(26,26,26,0.04), 0 4px 12px rgba(26,26,26,0.06)",
  boxShadowSecondary: "0 8px 24px rgba(26,26,26,0.08)",
} as const;

export type GlowTokens = typeof GLOW_TOKENS;
